import hash from 'object-hash';
import { memo, useMemo } from 'react';

import { language } from '@utilities/browser';

export const languageMap = {
  en: 'english',
  it: 'italian',
  fr: 'french',
  de: 'german',
  es: 'spanish',
  pt: 'portuguese',
  ru: 'russian',
};

const GptBanner = (props: {
  className?: string;
  slotType:
    | 'billboard'
    | 'slider'
    | 'slider-all'
    | 'interstitial'
    | 'mpu'
    | 'leaderboard'
    | 'leaderboard-small'
    | string;
  position: string;
  sponsor?: string;
  adUnitPath: string;
}) => {
  const { className, slotType, position, sponsor, adUnitPath } = props;

  const options = useMemo(
    () => ({
      type: slotType,
      position: position,
      sponsor: sponsor,
      adPath: adUnitPath.replace('{language}', languageMap[language]),
    }),
    [adUnitPath, position, sponsor, slotType],
  );

  const slotId = `div-gpt-ad-${hash(options)}`;

  return (
    <div
      id={slotId}
      className={`js-gpt-banner promoLibrary ${className} ${slotType}`}
      data-options={JSON.stringify(options)}
    />
  );
};

export default memo(GptBanner);
